<!-- redaction cell (with updated eye icon styling) -->
<div class="tw-relative tw-flex tw-items-center tw-h-full" (click)="toggleCell()">
  <span
    class="tw-truncate tw-block tw-pr-10"
    [ngClass]="{ 'tw-text-dt-text-disabled': isMasked() }"
  >
    {{ value }}
  </span>

  @if (this.earnTableService.breadCrumbState() === 'draft') {
  <span
    *ngIf="isMasked()"
    class="tw-cursor-pointer tw-absolute tw-right-0 tw-opacity-60 tw-w-[35px] tw-h-[35px] tw-flex tw-justify-center tw-items-center tw-bg-neutral-300 tw-rounded-sm"
  >
    <svg width="16" height="16" class="tw-text-dt-text-secondary">
      <use href="images/sprite.svg#eye-off"></use>
    </svg>
  </span>
  }
</div>
